/** `true` cuando hay valoraciones suficientes para mostrar puntuación
 * (spec.md FR-009/FR-010): sin dato, `0`, o por debajo del umbral ⇒ `false`. */
export function shouldShowRating(
  ratingSum: number | null | undefined,
  threshold: number,
): boolean {
  if (ratingSum == null) return false
  return ratingSum >= threshold
}
